import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class QuestionnaireTemplateServices {
    private serviceName = '/questionnaireTemplate';

    async GetQuestionaireTemplateByVariant(variantId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetQuestionaireTemplateByVariant/${variantId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async SubmitOrUpdateTemplate(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/SubmitOrUpdateTemplate`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetQuestionaireTemplateByCategory(productTypeId: any, osTypeId: any, categoryId: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetQuestionaireTemplateByCategory/${productTypeId}/${osTypeId}/${categoryId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

}

export default new QuestionnaireTemplateServices();